import * as React from 'react';
import SimpleButton from '../../../components/SimpleButton';
export class ButtonUnsuspend extends React.Component {
    render() {
        const buttonIcon = this.props.fillColor === 'red'
            ? {
                name: 'resume',
                style: {
                    fill: 'red',
                },
            }
            : {
                name: 'resume',
            };
        return (React.createElement(SimpleButton, Object.assign({ "data-name": "unsuspend", tooltip: "Pause", iconSize: 20, icon: buttonIcon, variant: "text" }, this.props)));
    }
}
